import { render, staticRenderFns } from "./PatientDetailImageDescription.vue?vue&type=template&id=2bf3caf5&scoped=true&"
import script from "./PatientDetailImageDescription.vue?vue&type=script&lang=ts&"
export * from "./PatientDetailImageDescription.vue?vue&type=script&lang=ts&"
import style0 from "./PatientDetailImageDescription.vue?vue&type=style&index=0&id=2bf3caf5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf3caf5",
  null
  
)

export default component.exports